import httpService from '../../../../services/httpService';

export interface DashboardData {
  total_learners: number;
  total_active_schedules: number;
  completion_rate: number;
  interview_schedules: any[];
  assessment_schedules?: any[];
}

const DashboardClient = {
  getDashboardData: async (offsetTime: string) => {
    const response = await httpService.get("/interview_admin/dashboard", {
      params: { offset_time: offsetTime }
    });
    return response.data;
  }
};

export default DashboardClient;
